//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/View.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AmbientOcclusion",1,0],[0,"DisplayStyle",0,0],[0,"GenerateHqiShadows",1,0],[0,"RealTimeType",1,0],[1,"ShadowCatcherSelection",0,"SelectNXObjectList",0],[0,"ShadowsEnabled",1,0],[0,"ShadowsShadedViewsShowGroundShadows",1,0],[0,"SoftShadowsBiasOffset",1,0],[0,"SoftShadowsEdges",1,0],[0,"SoftShadowsEnabled",1,0],[0,"SoftShadowsGradientClamp",1,0],[0,"SoftShadowsQuality",1,0],[0,"SsaoBlurRadius",1,0],[0,"SsaoContrast",1,0],[0,"SsaoQuality",1,0],[0,"SsaoRadius",1,0],[0,"UseShadowCatcher",1,0],[0,"View",0,"View",0]],[],[]];
SPLM.Display.Shadows = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.Shadows";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.Shadows.RealTimeState = Object.freeze({
    "Disabled" : "Disabled", "EnvironmentShadowCatcherOnly" : "EnvironmentShadowCatcherOnly", "InterObject" : "InterObject"});

SPLM.Display.Shadows.SsaoQualityType = Object.freeze({
    "Low" : "Low", "Medium" : "Medium", "High" : "High", "VeryHigh" : "VeryHigh"});

SPLM.Display.Shadows.SsaoContrastType = Object.freeze({
    "None" : "None", "Low" : "Low", "Medium" : "Medium", "High" : "High", "ExtraHigh" : "ExtraHigh"});

export default SPLM;